import '@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input';
// eslint-disable-next-line no-duplicate-imports
import JhaFormTextInput from '@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input';
import { html, PropertyValues } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { TmFormControl } from '../forms';

type JhaWcInputChanged = CustomEvent<string>;

const tagName = 'tm-text-input';

@customElement(tagName)
export class TmTextInput extends TmFormControl<string> {
    @property({ type: String })
    public placeholder?: string;

    @property({ type: String })
    public label?: string;

    @state()
    private firstChange = true;

    private readonly textInputRef = createRef<JhaFormTextInput>();

    private get textInput() {
        return this.textInputRef.value;
    }

    protected validate() {
        if (!this.textInput) {
            return true;
        }

        return this.textInput.checkValidity();
    }

    protected updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('initial')) {
            if (this.textInput && this.initial) {
                this.textInput.value = this.initial;
            }
        }
    }

    protected render() {
        return html`
            <jha-form-text-input
                ${ref(this.textInputRef)}
                @change=${(e: JhaWcInputChanged) => {
                    // The first change event is fired when the input is initialized with the initial value so we guard against calling changeValue() in that case
                    if (this.firstChange) {
                        this.firstChange = false;
                        return;
                    }
                    this.changeValue(e.detail);
                }}
                .label=${this.label ?? ''}
                .placeholder=${this.placeholder ?? ''}
                .value=${this.initial?.toString() ?? ''}
            ></jha-form-text-input>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmTextInput;
    }
}
